import React from "react";

export default function RekoProtests() {
    return (
        <div className="card">
            <h1>ReKo Proteste</h1>

            <p className="muted">
                Hier landet später die Protestübersicht aus der Datenbank.
            </p>

            <div
                style={{
                    marginTop: 18,
                    display: "grid",
                    gap: 12,
                    maxWidth: 760,
                }}
            >
                <div className="alert alert--ok">
                    Platzhalter: Neuer Protest eingegangen.
                </div>

                <div
                    style={{
                        border: "1px solid rgba(255,255,255,.12)",
                        borderRadius: 14,
                        padding: 16,
                        background: "rgba(255,255,255,.04)",
                    }}
                >
                    <div style={{ fontWeight: 700, marginBottom: 6 }}>
                        Protest #1
                    </div>

                    <div className="muted">
                        Beispielansicht für spätere Protestdaten: Rennen, Runde, beteiligte Fahrer,
                        Beschreibung, Status und ReKo-Entscheidung.
                    </div>

                    <div style={{ display: "flex", gap: 10, flexWrap: "wrap", marginTop: 14 }}>
                        <button className="btn" type="button">
                            Öffnen
                        </button>

                        <button className="btn" type="button">
                            Als gelesen markieren
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}